export { default, useDefaultProps } from "./DefaultPropsProvider.js";